export { default } from "~components/modules/single-story/variants/image-right/SingleStoryImageRight.integrity";
